import { render, staticRenderFns } from "./categorymodal.vue?vue&type=template&id=0cc0a959&"
import script from "./categorymodal.vue?vue&type=script&lang=js&"
export * from "./categorymodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports